import { Injectable } from '@angular/core';

export interface AlertSettings{
  class: AlertType,
  message: string;
}

export enum AlertType{
  ERROR = "danger",
  WARNING = "warning",
  INFO = "info",
  SUCCESS = "success"
}

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  alertSettings: AlertSettings;

  constructor() { }
}
